import { render, staticRenderFns } from "./OauthClientsTable.vue?vue&type=template&id=0e46d41a"
import script from "./OauthClientsTable.vue?vue&type=script&lang=js"
export * from "./OauthClientsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports